const MODULE_NAME = 'OfflineModule';

// eslint-disable-next-line import/prefer-default-export
export const SYNCHRONIZE_LOCAL_DATABASE = `${MODULE_NAME}/SYNCHRONIZE_LOCAL_DATABASE`;
